// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"b86437e7","832":"4f2fa5cc","912":"0a124a1b"}[chunkId] + ".chunk.js";
};